import { UseQueryOptions } from 'react-query'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { SourceName } from '../index'
import { getSourceNames } from './requests/get-source-names'

export function useSourceNames(
  organizationUuid: string,
  options?: UseQueryOptions<SourceName[], Error>
) {
  return useContrastQuery<{ organizationUuid: string }, SourceName[]>(
    [Query.SOURCE_NAMES, organizationUuid],
    getSourceNames,
    {
      organizationUuid
    },
    { cacheTime: 0, ...options }
  )
}
